<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <h1 class="page-title">{{ 'RIDE_HISTORY_PAGE_TITLE' | translate }}</h1>
        <p>{{ 'RIDE_HISTORY_PAGE_DESC' | translate }}</p>
        <ridango-date-period-selector
            [startDate]="startDate$ | async"
            [minStartDate]="minStartDate$ | async"
            [maxStartDate]="maxStartDate"
            [endDate]="endDate$ | async"
            [minEndDate]="minEndDate$ | async"
            [maxEndDate]="maxEndDate$ | async"
            [automaticEnd]="true"
            [diff]="diff$ | async"
            [showText]="false"
            [showPrint]="false"
            [dateFormat]="dateFormat"
            [allowFuture]="true"
            (startDateSet)="startUpdated($event)"
            (endDateSet)="endUpdated($event)"
            (commitPeriodSelect)="updateList()">
        </ridango-date-period-selector>

        <ridango-ui-basic-loading-spinner
            *ngIf="loading$ | async"
            [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
        </ridango-ui-basic-loading-spinner>

        <div
            class="purchase-detail-view-area-ticket"
            *ngIf="(loading$ | async) === false && (rides$ | async).length === 0">
            <p class="purchase-detail-view-area-ticket__title">{{ 'RIDE_HISTORY_PAGE_NO_RIDES' | translate }}</p>
            <p class="purchase-detail-view-area-ticket__description">
                {{ 'RIDE_HISTORY_PAGE_NO_RIDES_DESC' | translate }}
            </p>
        </div>

        <ng-container *ngIf="(loading$ | async) === false && (rides$ | async).length > 0">
            <ridango-table class="show-desktop hide-mobile" [isTable]="true">
                <div class="tableHeader" role="rowgroup">
                    <div class="row-items table-content odd" role="row">
                        <span class="col-item w1-5" role="columnheader">{{ 'TABLE_HEADER_STATUS' | translate }}</span>
                        <span class="col-item w2" role="columnheader">
                            {{ 'TABLE_HEADER_DATE_AND_TIME' | translate }}
                            <ridango-ui-sort-button
                                [descOrder]="ridesOrderDescending"
                                (onClick)="changeSortOrder($event)">
                            </ridango-ui-sort-button>
                        </span>
                        <span class="col-item w4" role="columnheader"
                            >{{ 'TABLE_HEADER_PICK_UP' | translate }} • {{ 'TABLE_HEADER_DROP_OFF' | translate }}</span
                        >
                        <span class="col-item w1-5" role="columnheader">{{ 'TABLE_HEADER_VEHICLE' | translate }}</span>
                        <span class="col-item w1" role="columnheader">{{ 'TABLE_HEADER_PRICE' | translate }}</span>
                        <span class="col-item w2" role="columnheader">{{
                            'TABLE_HEADER_PAYMENT_METHOD' | translate
                        }}</span>
                    </div>
                </div>

                <div role="rowgroup">
                    <ridango-table-row
                        *ngFor="
                            let ride of rides$
                                | async
                                | sort: 'starting_point_timestamp' : 'datestring' : ridesOrderDescending;
                            let even = even
                        "
                        [isEven]="even">
                        <span class="col-item w1-5">{{ getStatus(ride.status) | translate }}</span>
                        <span class="col-item w2" *ngIf="ride.priority_time === 'DEPARTURE'"
                            >{{ ride.starting_point_timestamp | date: rowDateFormat }}
                            {{ 'RIDE_PICKUP_TIME' | translate }}</span
                        >
                        <span class="col-item w2" *ngIf="ride.priority_time === 'ARRIVAL'"
                            >{{ ride.destination_timestamp | date: rowDateFormat }}
                            {{ 'RIDE_DROPOFF_TIME' | translate }}</span
                        >
                        <span class="col-item w4"
                            >{{ ride.starting_point_address }} > {{ ride.destination_address }}</span
                        >
                        <span class="col-item w1-5">{{ ride.location_reg_number }}</span>
                        <span class="col-item w1" *ngIf="ride.price"
                            >{{ ride.price | thousandsFormat }} {{ appStartupService.getCurrency() | translate }}</span
                        >
                        <span class="col-item w1" *ngIf="!ride.price">{{ 'PRICE_UNAVAILABLE' | translate }}</span>
                        <span class="col-item w2">{{
                            getPaymentMethod(ride.shopping_cart_payment_type) | translate
                        }}</span>
                    </ridango-table-row>
                </div>
            </ridango-table>

            <ridango-table class="hide-desktop show-mobile" [isTable]="false">
                <ridango-table-row *ngFor="let ride of rides$ | async; let even = even" [isEven]="even">
                    <div class="wcag-hidden hide-desktop show-mobile">{{ 'TABLE_HEADER_STATUS' | translate }}</div>
                    <div class="col-item w4">{{ getStatus(ride.status) | translate }}</div>

                    <div class="wcag-hidden hide-desktop show-mobile">
                        {{ 'TABLE_HEADER_DATE_AND_TIME' | translate }}
                    </div>
                    <span class="col-item w4" *ngIf="ride.priority_time === 'DEPARTURE'"
                        >{{ ride.starting_point_timestamp | date: 'dd.MM.y HH:mm' }}
                        {{ 'RIDE_PICKUP_TIME' | translate }}</span
                    >
                    <span class="col-item w4" *ngIf="ride.priority_time === 'ARRIVAL'"
                        >{{ ride.destination_timestamp | date: 'dd.MM.y HH:mm' }}
                        {{ 'RIDE_DROPOFF_TIME' | translate }}</span
                    >

                    <div class="wcag-hidden hide-desktop show-mobile">
                        {{ 'TABLE_HEADER_PICK_UP' | translate }} • {{ 'TABLE_HEADER_DROP_OFF' | translate }}
                    </div>
                    <div class="col-item w2-5 desktop-center mobile-left">
                        {{ ride.starting_point_address }} > {{ ride.destination_address }}
                    </div>
                </ridango-table-row>
            </ridango-table>
        </ng-container>
    </div>
</div>
